import React from 'react';
import { CycleMark } from './CycleMark';
type Tome = {
  number: string;
  title: string;
  cards: string;
  promise: string;
  band: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'Read the Machine',
  cards: 'FPC 01–15',
  promise: 'The Freeze-or-Harvest Split and First-15 Triage: the cycle and the system in 15 minutes.',
  band: 'bg-forest',
  contents: ['Identify cube, nugget, flake, modular, remote or dispenser at a glance', 'Read the data plate and the sequence of operation in 6 stages', 'The Split decision tree and the 4-System Map', 'Decode fault lights and error codes with a 4-step method', 'Safe lockout, service modes and diagnostic modes']
}, {
  number: '02',
  title: 'Symptom-to-Part Flowcharts',
  cards: 'FPC 16–42',
  promise: 'No ice, bad ice, harvest faults, leaks and dispensers — symptom to suspect part.',
  band: 'bg-ember-deep',
  contents: ['No-ice and low-production flowcharts, modular heads included', 'Cube pattern guide: thin, cloudy, hollow, fused or slushy ice', 'Long harvest, ice not dropping, stuck in harvest', 'Recover a freeze-up without damaging the evaporator', 'Leaks, noise, auger and dispenser faults + the Repeat-Call Trap List']
}, {
  number: '03',
  title: 'Component Testing Bench',
  cards: 'FPC 43–65',
  promise: 'Prove the part before you replace it.',
  band: 'bg-moss-deep',
  contents: ['The Prove-It-Twice Rule and Signal-Load-Path', 'Inlet valve, water pump, level sensor, purge and drain valves', 'Hot gas valve, thickness probe, bin controls and thermistors', 'Control board, transformer, contactor, fans and auger motor', '9 checks before you order a control board']
}, {
  number: '04',
  title: 'Refrigeration & Environment',
  cards: 'FPC 66–86',
  promise: 'Pressures, superheat, subcooling, condensers and the room around the machine.',
  band: 'bg-sys-refrig',
  contents: ['Heat In / Heat Out Balance and the Freeze Curve Read', 'Temperature-clamp survey before you connect gauges', 'Undercharge vs overcharge, expansion valve, restrictions', 'Air, water and remote condensers — machine fault vs site fault', 'Certified-only steps clearly marked for your country']
}, {
  number: '05',
  title: 'Water, Scale & Sanitation',
  cards: 'FPC 87–105',
  promise: 'Test, treat, descale, sanitize — and keep logs ready for inspection.',
  band: 'bg-sky-deep',
  contents: ['The 3S Water Read: Scale, Slime, Sediment', 'Water testing, filter sizing and changes by condition', 'Descale cube, nugget and flake machines in the right order', 'Sanitize the food zone, remove biofilm, recover after contamination', 'Monthly logs, inspection binder cover sheet and staff checklist']
}, {
  number: '06',
  title: 'Service Paperwork & Accounts',
  cards: 'FPC 106–124',
  promise: 'PM, reports, repair-vs-replace, parts, warranty and follow-up.',
  band: 'bg-bark',
  contents: ['The PM Ladder: quarterly, semi-annual and annual visits', 'Service agreement, 5-minute service report and estimates', 'The Fix-Keep-Replace Score for repair-vs-replace calls', 'Van stock list, part matching and warranty claim prep', 'Equipment history and follow-up after every type of visit']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="grid-light w-full bg-paper" data-id="element-360" data-mp="ivlpcrtte21u">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-361" data-mp="mvmcd0uzblki">
        <div className="text-center" data-id="element-362" data-mp="rn5j0zjlhlpy">
          <p className="eyebrow text-ember-deep" data-id="element-363" data-mp="ro77c5pmg4pm">The service call, in order</p>
          <h2 id="tomes-heading" className="rule-underline mt-3 font-display text-[34px] uppercase leading-tight text-pine sm:text-6xl" data-id="element-364" data-mp="3rboyz34hm0st">
            Inside the pack — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-pine-soft" data-id="element-365" data-mp="3c8dpsdvezcqn">
            The volumes follow a real visit: locate the fault, follow the
            symptom, prove the part, open the sealed system only if you need
            to, fix the root cause and close the job. Each one also works on its
            own.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-366" data-mp="3uy3ld37042jm">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col overflow-hidden rounded-2xl border border-paper-dark bg-white shadow-card" data-id="element-367" data-mp="3pzs9kmx5bhyr">
              <div className={`relative overflow-hidden ${tome.band}`} data-id="element-368" data-mp="3s2el6u2jv3s">
                <CycleMark className="pointer-events-none absolute -right-6 -top-8 h-28 w-28 text-white/20" data-id="element-369" data-mp="3pzgs0mocxoi" />
                <div className="relative flex items-center justify-between px-5 py-3.5" data-id="element-370" data-mp="2akd1a7d4wv0t">
                  <span className="font-mono text-[11px] font-bold uppercase tracking-[1.5px] text-white/90" data-id="element-371" data-mp="25li8qdpd7s3i">
                    Volume {tome.number} · {tome.cards}
                  </span>
                  <span className="font-display text-4xl leading-none text-white" data-id="element-372" data-mp="pzobd8nlk4bq">
                    {tome.number}
                  </span>
                </div>
              </div>

              <div className="spec-card flex flex-1 flex-col p-6 pt-5" data-id="element-373" data-mp="g9d5vho9ln2q">
                <h3 className="font-display text-2xl uppercase leading-snug text-pine" data-id="element-374" data-mp="2anb48ox3zhj">
                  {tome.title}
                </h3>
                <p className="mt-1.5 text-sm text-pine-soft" data-id="element-375" data-mp="6dten8knbckb">{tome.promise}</p>
                <ul className="mt-4 grid gap-2 border-t border-paper-dark pt-4" data-id="element-376" data-mp="3ojes2oajtt90">
                  {tome.contents.map(item => <li key={item} className="flex gap-2.5 text-[14px] leading-snug text-pine" data-id="element-377" data-mp="3tjanhz56kccy">
                      <span className="mt-[6px] h-2 w-2 flex-none rounded-full bg-ember" data-id="element-378" data-mp="1monl6s3txe61" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}